module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-required": true,
      "show-hide-in-form": true,
      "show-hide-in-reports": true,
      "show-hide-in-preview": true,
      "show-share-with-participant": true,
      "show-is-shared": true
    }
  }, _vm.$listeners))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61435924","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorSignature.vue
// module id = 1665
// module chunks = 1